import { Pipe, PipeTransform } from '@angular/core';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';

@Pipe({
    name: 'hasDemoAccess',
    standalone: false,
})
export class HasDemoAccessPipe implements PipeTransform {
    constructor (private demoHasAccessService: DemoHasAccessService) {}

    transform (module: string) {
        switch (module) {
            case 'pdf_accessibility':
                return this.demoHasAccessService.canAccessAccessibilityPDF();
            case 'page_statistics':
                return this.demoHasAccessService.useStatisticsDemoData();
            default:
                return false;
        }
    }

}
